import { useLayoutEffect, useState } from 'react';

import { scrollOverflow } from './columnLayout';

const EMPTY = { start: false, end: false };

export function useScrollEdges(element: HTMLElement | null) {
  const [edges, setEdges] = useState(EMPTY);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    let frame = 0;
    const measure = () => {
      frame = 0;
      const next = scrollOverflow(element.scrollLeft, element.scrollWidth, element.clientWidth);
      setEdges((current) => (current.start === next.start && current.end === next.end ? current : next));
    };
    const schedule = () => {
      if (!frame) {
        frame = requestAnimationFrame(measure);
      }
    };

    measure();
    element.addEventListener('scroll', schedule, { passive: true });
    if (typeof ResizeObserver === 'undefined') {
      return () => {
        element.removeEventListener('scroll', schedule);
        if (frame) {
          cancelAnimationFrame(frame);
        }
      };
    }

    const observer = new ResizeObserver(schedule);
    observer.observe(element);
    return () => {
      element.removeEventListener('scroll', schedule);
      observer.disconnect();
      if (frame) {
        cancelAnimationFrame(frame);
      }
    };
  }, [element]);

  return edges;
}
